import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <App />,
)

// PWA Service Worker登録 - ページ完全安定後に実行
// iframe内（プレビュー環境）やローカルホスト以外のHTTPではSW登録をスキップ
const isInIframe = window.self !== window.top
const isSecureContext = window.isSecureContext || window.location.protocol === 'https:' || window.location.hostname === 'localhost'

if ('serviceWorker' in navigator && !isInIframe && isSecureContext) {
  // より安全な登録タイミング制御
  let registrationAttempted = false
  
  const attemptRegistration = () => {
    // 重複登録を防止
    if (registrationAttempted) return
    
    // ドキュメントの完全な準備を確認
    if (document.readyState !== 'complete' || 
        !document.body || 
        !document.documentElement) {
      return
    }
    
    registrationAttempted = true
    
    // より遅延させて確実に安定させる
    const register = () => {
      try {
        navigator.serviceWorker.register('/sw.js', { scope: '/' })
          .then(registration => {
            console.log('✅ Service Worker登録成功:', registration.scope)
          })
          .catch(error => {
            // すべてのエラーを静かに処理（本番環境では正常動作）
            if (error.name === 'InvalidStateError') {
              // ドキュメント状態エラーは無視（プレビュー環境特有）
            } else if (error.name === 'SecurityError') {
              // セキュリティエラーも無視（HTTP環境等）
            }
            // その他のエラーも無視
          })
      } catch (error) {
        // 同期エラーも無視
      }
    }
    
    // requestIdleCallbackでアイドル時に登録（最も安全）
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(register, { timeout: 8000 })
    } else {
      // フォールバック: 十分な遅延を確保
      setTimeout(register, 5000)
    }
  }
  
  // ページロード完了を待機
  if (document.readyState === 'complete') {
    setTimeout(attemptRegistration, 3000)
  } else {
    window.addEventListener('load', () => {
      setTimeout(attemptRegistration, 3000)
    })
  }
}
